<template>
    <div class="gray-game-stats hours-online">
        <h1>
            <span class="blue">{{playTime.count.toLocaleString()}} часов</span><br>
            <span>проведено на сервере</span>
        </h1>
        <tag v-if="this.playTime.position">{{top}}</tag>
    </div>
</template>

<script>
    import tag from '@/elements/tag.vue'
    import {mapState} from "vuex";

    export default {
        name: "hours_online",
        props:{
            playTime: Object
        },
        components:{
            tag,
        },
        computed: {
            top(){
                if(this.playTime.position) return `${this.playTime.position.toLocaleString()} в топе`;
                else return 'еще не в топе';
            },
        }
    }
</script>

<style scoped lang="scss">
    .hours-online{
        align-self: flex-start;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        h1{
            margin-bottom: 12px;
            .blue{
                color: $blue;
            }
        }
        @include tablet{
            margin-bottom: 0;

        }
    }
</style>
